/* The wordmark, in two pieces.

   BrandGlyph is the emblem on its own. The sidebar paints its own `.brand-logo`
   tile and its own `.brand-name`, so handing it the full BrandMark nested one
   green tile inside another and printed "TalentFlow" twice — once inside the
   tile, once beside it. Callers that already supply their own chrome take the
   glyph; callers that want the whole lockup (the auth screens) take the default. */

/** The emblem's outline (viewBox 0 0 100 64.46); the global loader animates it too. */
export const BRAND_GLYPH_PATH = 'M100 3.65C97.86 20.99 91.89 43.03 79.48 55.33 76 58.77 71.84 61.46 66.96 62.14 50.4 64.46 41.84 47.5 29.07 42.7 21.85 39.98 14.5 42.02 9.66 47.95 6.54 51.78 4.49 56.35 2.97 61.13 2.41 61.64 0.97 61.66 0 61.31L0 0.13C1.05 0 2.27 0.02 3.09 0.28 14.9 15.86 26.77 30.82 40.15 45.28L60.79 24.7C67.38 18.22 74.41 12.74 82.59 8.51 88.11 5.83 93.64 3.93 100 3.65Z'

export function BrandGlyph() {
  return (
    <svg className="brand-mark" viewBox="0 0 100 64.46" aria-hidden="true">
      <path d={BRAND_GLYPH_PATH} />
    </svg>
  )
}

export default function BrandMark({ size = 'md', showName = true }) {
  const logoClass = size === 'lg' ? 'brand-logo brand-logo-lg' : 'brand-logo'
  return (
    <div className="auth-brand">
      <div className={logoClass}>
        <BrandGlyph />
      </div>
      {showName ? <span className="brand-name">TalentFlow</span> : null}
    </div>
  )
}
